<template>
    <div>
        <div class="special-offer-eyebrow">Special Offer Ends In {{ formattedTime }}</div>
        <h1 class="onboarding-title">Upgrade in the Next 2 Hours to Get 50% Off for 3 Months</h1>
        <p class="onboarding-desc">If you're ready to make a difference
            in your business, we're ready to make it
            easier than ever to upgrade. Get the most out of Ashore today with 50% off
            any plan for the next three months.</p>
        <div class="onboarding-card">
            <div class="onboarding-card-section">
                <h6 class="onboarding-card-heading">Why Upgrade?</h6>
                <ul class="feature-list">
                    <li v-for="(item, index) in orderedFeatures" :key="index">
                        <img src="/img/check.svg" width="16" alt="Check">
                        <span>{{ item }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="onboarding-actions">
            <button @click="handleUpgrade" class="auth-btn-primary">Upgrade</button>
            <button @click="handleSkipUpgrade" class="auth-btn-ghost">Skip</button>
        </div>
    </div>
</template>

<script>

import { ROUTES } from '../../utils/constants.js'
import { deleteCookie, isEligibleForFirstTimeOffer } from '../../utils/helpers.js'

export default {
    name: "Screen4",
    data() {
        return {
            countdownSeconds: 7200,
        }
    },
    props: {
        featuresCanUnlock: {
            type: Array,
            required: true
        },
        currentStep: {
            type: Number,
            required: true
        }
    },
    async mounted() {
        await this.setOnboarding();
    },
    beforeDestroy() {
        this.clearCountdown();
    },
    methods: {
        handleCheckListItemDelete(id) {
            const index = this.checkListItem.findIndex(item => item.id === id);
            if (index !== -1) {
                this.checkListItem.splice(index, 1);
            }
        },
        handleCheckListItem() {
            this.checkListItem.push({ id: this.checkListItem.length, message: "" });
        },
        setOnboarding: async function () {
            try {
                deleteCookie('isPromoBannerClosed');
                const currentUser = _.get(this, '$A.Auth', null);
                if (!currentUser) return;
                const response = await this.$A.UserService.UpdateUser(currentUser.id, { onboardingStep: this.currentStep, email: currentUser.email })

                if (response) {
                    this.$A.UpdateUserObjectAndBustCache(response);
                    const onboardedAtTimestamp = new Date(response.onboardedAt + 'Z').getTime();
                    const now = new Date();
                    const elapsedSeconds = Math.floor((now.getTime() - onboardedAtTimestamp) / 1000);
                    this.countdownSeconds = Math.max(7200 - elapsedSeconds, 0);

                    if (isEligibleForFirstTimeOffer(this.$A.Auth)) {
                        this.startCountdown();
                    }
                }
            } catch (error) {
                this.$A.AlertUser("Failed to update onboarding state. Please try again.", "error");
            }
        },
        handleUpgrade: function() {
            window.open(ROUTES.BILLING, '_self');
        },
        handleSkipUpgrade: function() {
            window.open(ROUTES.OVERVIEW , '_self');
        },
        startCountdown() {
            this.clearCountdown();
            this.timer = setInterval(() => {
                if (this.countdownSeconds > 0) {
                    this.countdownSeconds--;
                } else {
                    this.clearCountdown();
                }
            }, 1000);
        },
        clearCountdown() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
    },
    computed: {
        orderedFeatures() {
            return this.featuresCanUnlock;
        },
        formattedTime() {
            const hours = Math.floor(this.countdownSeconds / 3600);
            const minutes = Math.floor((this.countdownSeconds % 3600) / 60);
            const seconds = this.countdownSeconds % 60;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
    }
};
</script>

<style scoped>
.special-offer-eyebrow {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #019256;
    margin-bottom: 8px;
    font-variant-numeric: tabular-nums;
}
</style>
